export default __webpack_public_path__ + "static/media/keyboardArrowLeft.b2a096be.svg";